import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import { deleteFromS3 } from '../../lib/s3'

export const deleteNote = createServerFn({ method: 'POST' })
  .inputValidator(z.object({ noteId: z.string().min(1) }))
  .handler(async (ctx): Promise<{ success: boolean }> => {
    await deleteFromS3(`notes/${ctx.data.noteId}.json`)
    return { success: true }
  })
